<template>
    <v-timeline-item small :color="color" left :icon="icon" >
      <v-card class="elevation-2" shaped>
        <v-card-title class="headline">
          <i v-text="line.level" class="pr-2" :style="{ color }" />
          {{line.msg}}
        </v-card-title>
        <v-card-text>
          <span style="font-family:Consolas,Ubuntu Mono" v-html="line.className"></span>
          <br />
          <span>
            <b v-text="line.timestamp" />
          </span>
        </v-card-text>
        <v-card-actions v-if="line.details">
          <v-expansion-panels class="mx-4">
            <v-expansion-panel>
              <v-expansion-panel-header v-text="$t('monitoring.details.details')" />
              <v-expansion-panel-content>
                <Details
                  v-for="key in Object.keys(line.details)"
                  :detail-value="line.details[key]"
                  :detail-key="key"
                  :key="key"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-actions>
      </v-card>
    </v-timeline-item>
</template>
<script>
import Details from './Details.vue'
import Utils from '../../utils'

export default {
  name: 'TimelineItem',

  components: { Details },

  props: {
    line: Object
  },

  computed: {
    color () { return Utils.getLevelColor(this.line.level) },
    icon () { return (this.line === true) ? 'mdi-format-text-wrapping-overflow' : '' }
  }

}
</script>
